import React, { useRef, useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getFromApi, sendToApi, sendToApiReturn } from 'API/teacherCalls';

import styles from './ManageSubscription.module.scss';
import { dateFormatYear } from 'helpers/dateFunctions';
import { showModal } from 'helpers/uiFunctions';
import spinner from 'assets/spinner-sml--fast.svg';
import { format } from 'date-fns';
import queryString from 'query-string'

const ManageSubscription = ({ modalOverlay }) => {

  const [ subData, setSubData ] = useState();
  const [ updateRes, setUpdateRes ] = useState({});
  const [ error, setError ] = useState({vis:false, conf:false, text:''});
  const [ showSpinner, setShowSpinner ] = useState(false)
  const [ paymentHistory, setPaymentHistory ] = useState([]);
  const location=useLocation()
  const parsed = queryString.parse(location.search)
  const [ cardDiv , toggleCardDiv ] = useState(parsed.addCard);

  const cardRef = useRef();
  const formRef = useRef();
  const chevRef = useRef();
  const nameRef = useRef();
  const numberRef = useRef();
  const expRef = useRef();
  const cvcRef = useRef();
  let regex = /[0-9]|\./;
  const isCancelled = subData && subData.plusStatus && subData.plusStatus === "cancelled"

  const callAPI = async () => { setSubData(await getFromApi('plus_details')) }


  useEffect(()=>{
    if(updateRes.message&&updateRes.message==='error'){
      setTimeout(()=>{
        setShowSpinner(false)
        setError({vis:true, text:'Something went wrong, please check your information'})
      },550)
    } else if(updateRes.cardEnding) {
      console.log('update')
        setTimeout(()=>{
          setShowSpinner(false)
          setError({...error, conf:true})
          setSubData(updateRes)
        },550)
    }

  },[updateRes])

  useEffect(()=>{if(subData&&subData.paymentHistory){setPaymentHistory(subData.paymentHistory.reverse())}},[subData])
  
  
  const handleCreditCard = async () =>{

    setError({...error, vis:false, conf:false})

    if(nameRef.current.value===""||numberRef.current.value===""||expRef.current.value===""||cvcRef.current.value===""){
      formRef.current.classList.add('shake')
      setTimeout(()=>{formRef.current.classList.remove('shake')},500)
      setError({vis:true, text:'Please complete all fields'})

    } else {
      setShowSpinner(true)
      const payload={
        name:nameRef.current.value,
        card_number:numberRef.current.value.split(' ').join(''),
        expiration_date:expRef.current.value,
        cvc:cvcRef.current.value
      }
      const res = await sendToApiReturn('plus_update_card', payload )
      setUpdateRes(res)
    }

  }

  const formatInput = (e, variant)  => {

    if(variant==='card' && e.key!=='Backspace' && e.key!=='Tab'){

      const x = e.target;
      if(x.value.length === 4){x.value=x.value+' '}
      if(x.value.length === 9){x.value=x.value+' '}
      if(x.value.length === 14){x.value=x.value+' '}

    } 

    if(variant==='month' && e.key!=='Backspace' && e.key!=='Tab' ){
      const x = e.target;
      if(x.value.length === 2){x.value=x.value+'/'}
    }
    

    if( !regex.test(e.key) && e.key!=='Backspace' && e.key!=='Tab' ) {
      e.returnValue = false;
      if(e.preventDefault) e.preventDefault();
    }
  }

    
  useEffect(()=>{ 
    callAPI()
  },[])
    
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Manage Subscription</h1>

      <Link to='/teacher/account/subscription'
        className={styles.back}>{'< Back'}
      </Link>

      <div className={styles.main}>
        {
          subData && subData.subscription ? 
            <>
              <div className={styles.left}>

                <div className={styles.block}>
                  <h4>Your Subscription</h4>

                  <div className={styles.row}>

                    {
                      <p>Escribli {subData.subscription} plan</p>
                    }

                    <p>{subData.subscription !== 'trial'&&subData.price  ? `$${subData.price}` : '$0.00'}</p>
                  </div>
                  <div className={styles.row}>

                    <p>{subData.subscription === 'trial' ? 'Trial days remaining' : subData.plusStatus === 'cancelled' ? 'Cancellation date' : 'Automatic renawal date'}</p>

                    <p>{subData.subscription === 'trial' ? subData.trialDaysLeft : isCancelled ?  dateFormatYear(subData.cancelledOn) : dateFormatYear(subData.renewalDate)  }</p>


                  </div>
                  <div className={styles.row}>
                    <p>Current credit card info</p>
                    {
                    subData.cardEnding !== '****' ?
                      <p className={styles.cardNumber}>Ending in {subData.cardEnding}</p> 
                    :
                      <p className={styles.cardNumber}>No card on file</p>
                    } 
                  </div>
                </div>

                <div ref = { cardRef } className={`${styles.block} ${styles.cardDetails} ${cardDiv && styles.open}`}>
                  <h4 onClick = {()=>toggleCardDiv(!cardDiv) } >Update credit card information
                  <div ref = { chevRef } className={ `${styles.chevron} ${cardDiv && styles.open }` }></div>
                  </h4>

                  <div ref={formRef} className={styles.form}>
                    <label htmlFor="name">Name on card</label>
                    <input placeholder="John Doe" type="text" name="name" id="name" ref={nameRef} onChange={()=>{setError({...error, vis:false})}}/>
                    <label htmlFor="cardNumber">Card number</label>
                    <input 
                    ref={numberRef}
                    onKeyDown={(e)=>{ formatInput(e, 'card'); setError({...error, vis:false}) }}
                    placeholder="0000 0000 0000 0000" 
                    type="text" 
                    name="number" 
                    id="cardNumber" 
                    maxLength="19"
                    />

                  <div className={styles.bottom}>
                    <div>
                      <label htmlFor="exp">Expiration</label>
                      <input onKeyDown={(e)=>{formatInput(e, 'month'); setError({...error, vis:false})}} placeholder="MM/YY" type="text" name="exp" id="exp" maxLength={5} ref={expRef}/>
                    </div>
                    <div>
                      <label htmlFor="cvc">CVC</label>
                      <input onKeyDown={(e)=>{formatInput(e, 'card'); setError({...error, vis:false})}} maxLength="3" placeholder="000" type="text" name="cvc" id="cvc" ref={cvcRef}/>
                    </div>
                  </div>

                  </div>
                  <div className={styles.buttons}>
                    {
                      showSpinner && <img src={spinner} alt="spinner" />
                    }
                    {
                      error.vis&&<p className={styles.error}>{error.text}</p>
                    }
                    {
                      error.conf&&<p className={styles.conf}>Information updated succesfully!</p>
                    }
                    <div onClick={handleCreditCard} className={styles.btn}>
                      Update credit card
                    </div>
                  </div>
                </div>

              </div>

              <div className={styles.right}>

                <div className={`${styles.paymentHistory} ${styles.block}`}>
                  <h4>Payment History</h4>

                  <div className={styles.historyHeader}>
                    <h4>Plan</h4>
                    <h4>Date</h4>
                    <h4>Amount</h4>
                  </div>

                  <div className={styles.historyRows}>
                    {
                      subData.paymentHistory.length? 

                        paymentHistory.map((item, idx) =>{
                          return(
                            <div className={styles.historyRow}>
                            <p>{item.plan} Plan</p>
                            <p>{dateFormatYear(item.date)}</p>
                            <p>${item.amount}</p>
                          </div>
                          )
                        })

                      : 
                        <p className={styles.noHistory}>No history</p>
                    }
                    
                  </div>

                </div>

                {/* <div className={styles.block}>
                  <h4>Change Subscription</h4>


                { 
                  subData.subscription === 'complete' || subData.subscription === 'basic' ?
                    <p onClick={()=>{ showModal(modalOverlay, {type:'manageSubscription', subData:subData, setSubData:setSubData})}} className={styles.blue}>Update Plan (up to 25% discount for multi payment plans) </p>

                  : 
                    <p onClick={()=>{ showModal(modalOverlay, {type:'manageSubscription', subData:subData, setSubData:setSubData})}} className={styles.blue}>Purchase Plan (up to 25% discount for multi payment plans) </p>
                }

               {!isCancelled ? 
                 <p onClick={()=>{ showModal(modalOverlay, {type:'cancelSubscription', subData:subData, setSubData:setSubData})}} className={styles.cancelSub}>Cancel Subscription</p>
                :

                <>
                  <p className={styles.isCancelled}>Subscription Cancelled</p>
                  <p className={styles.subtext}>*You can continue to use premium features until your scheduled renewal date: { format(new Date(subData.renewalDate), 'MMM dd, yyyy') }</p>
                </>
                
                }

                </div> */}
            </div>
          </>

        :

          <div className={styles.loader}>
            <img src={spinner} alt="spinner"/>
            <h6>Loading subscription data...</h6>
          </div>

        }

      </div>
    </div>
  )

}

export default ManageSubscription;